<header>
  <div class="header_inner">
    <b class="menu" id="openPop">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6H20M4 12H20M4 18H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </b>
    <div class="logo">
      <a href="https://www.gradpilots.com" title="Home">
        <img src="assets/images/logo.svg" alt="Logo">
      </a>
    </div>
    <a [routerLink]="['/student-signup']" class="g_login" target="_blank" title="Get Started Today">
      Get Started
    </a>
    <nav id="popMenu" #popMenu>
      <span id="closePop"></span>
      <div class="nav_inner">
        <div class="logonav">
          <a href="https://www.gradpilots.com" title="Home">
            <img src="assets/images/logo.svg" alt="Logo">
          </a>
        </div>
        <ul>
          <li>
            <a title="About Us" class="nav_arrow cursor-pointer"><i>About Us</i> <span></span></a>
            <div class="sub_menu">
              <div class="submenuinenr">
                <a href="https://www.gradpilots.com/our-mission.html">Our Mission</a>
                <a href="https://www.gradpilots.com/our-mentors.html">Our Mentors</a>
                <a href="https://www.gradpilots.com/contact-us.html">Contact Us</a>
                <!-- <a [routerLink]="['/contact-us']">Contact Us</a> -->
              </div>
            </div>
          </li>
          <li>
            <a title="About Us" class="nav_arrow cursor-pointer"><i>Mentor Me</i> <span></span></a>
            <div class="sub_menu">
              <div class="submenuinenr">
                <a href="https://www.gradpilots.com/mentor-me.html">Find a Mentor</a>
                <a [routerLink]="['/mentor-signup']">Become a Mentor</a>
                <a [routerLink]="['/peer-signup']">Become a Peer</a>
              </div>
            </div>
          </li>
          <li>
            <a title="Services" class="nav_arrow cursor-pointer"><i>Services</i> <span></span></a>
            <div class="sub_menu">
              <div class="submenuinenr">
                <a href="https://www.gradpilots.com/all-services.html">All Services</a>
                <a href="https://www.gradpilots.com/gradpath.html">GradPath</a>
                <a href="https://www.gradpilots.com/post-admission-services.html">Post Admission Services</a>
              </div>
            </div>
          </li>
          
          <li>
            <a title="Resources" class="nav_arrow cursor-pointer"><i>Resources</i> <span></span></a>
            <div class="sub_menu">
              <div class="submenuinenr">
                <a href="https://www.gradpilots.com/admission-calendar.html">Admission Calendar</a>
                <a [routerLink]="['/roi-calculator']">ROI Calculator</a>
                <a href="https://www.gradpilots.com/explore-scholarships.html">Explore Scholarships</a>
                <a href="https://www.gradpilots.com/visa-and-work-eligibility.html">Visa & Work Eligibility</a>
                <a href="https://www.gradpilots.com/college-rankings.html">College Rankings</a>
                <a href="https://blog.gradpilots.com/">Blog</a>
              </div>
            </div>
          </li>
          <li>
            <a title="Destinations" class="nav_arrow cursor-pointer"><i>Destinations</i> <span></span></a>
            <div class="sub_menu">
              <div class="submenuinenr">
                <div>
                  <a href="https://www.gradpilots.com/study-in-india.html" class="nested-trigger">India</a>
                  <div class="nested-submenu">
                    <a href="https://www.gradpilots.com/delhi.html">Delhi</a>
                    <a href="https://www.gradpilots.com/mumbai.html">Mumbai</a>
                    <a href="https://www.gradpilots.com/kolkata.html">Kolkata</a>
                  </div>
                </div>
                <a href="https://www.gradpilots.com/study-in-usa.html">USA</a>
                <a href="https://www.gradpilots.com/study-in-canada.html">Canada</a>
                <a href="https://www.gradpilots.com/study-in-uk.html">UK</a>
              </div>
            </div>

            <li>
            <a title="Shop" [routerLink]="['/shop']" class="cursor-pointer"><i>Shop</i></a>
          </li>
        </ul>
        <div class="get_started">
          <a [routerLink]="['/student-signup']" class="get_start" target="_blank" title="Get Started Today">
            Get Started Today
          </a>

          <p-button label="Login as" (onClick)="menu.toggle($event)" severity="contrast" icon="pi pi-bars"
            styleClass="drop" />
          <p-tieredMenu #menu [model]="items1" [popup]="true" styleClass="tiredmenu" appendTo="body" />
        </div>
      </div>
    </nav>
  </div>
</header>